import { render, staticRenderFns } from "./CollapsibleTree.vue?vue&type=template&id=70ad32de&scoped=true"
import script from "./CollapsibleTree.vue?vue&type=script&lang=js"
export * from "./CollapsibleTree.vue?vue&type=script&lang=js"
import style0 from "./CollapsibleTree.vue?vue&type=style&index=0&id=70ad32de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ad32de",
  null
  
)

export default component.exports